import { render, staticRenderFns } from "./ArticleTag.vue?vue&type=template&id=532bbe1c&scoped=true&"
import script from "./ArticleTag.vue?vue&type=script&lang=js&"
export * from "./ArticleTag.vue?vue&type=script&lang=js&"
import style0 from "./ArticleTag.vue?vue&type=style&index=0&id=532bbe1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532bbe1c",
  null
  
)

export default component.exports